// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DashboardCheckUpQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type DashboardCheckUpQuery = {
  __typename?: "GraphqlQuery";
  getCheckUpStatus: {
    __typename?: "CheckUpStatus";
    id: string;
    critical: boolean;
    issueGroups: Array<{
      __typename?: "CheckUpIssueGroup";
      id: string;
      groupName: string;
      checkName: string;
      status: string;
      message: string;
      count: number;
    } | null>;
  };
};

export const DashboardCheckUpDocument = gql`
  query DashboardCheckUp($databaseId: ID!) {
    getCheckUpStatus(databaseId: $databaseId) {
      id
      critical
      issueGroups {
        id
        groupName
        checkName
        status
        message
        count
      }
    }
  }
`;

/**
 * __useDashboardCheckUpQuery__
 *
 * To run a query within a React component, call `useDashboardCheckUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCheckUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCheckUpQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useDashboardCheckUpQuery(
  baseOptions: Apollo.QueryHookOptions<
    DashboardCheckUpQuery,
    DashboardCheckUpQueryVariables
  > &
    (
      | { variables: DashboardCheckUpQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardCheckUpQuery, DashboardCheckUpQueryVariables>(
    DashboardCheckUpDocument,
    options,
  );
}
export function useDashboardCheckUpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardCheckUpQuery,
    DashboardCheckUpQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardCheckUpQuery,
    DashboardCheckUpQueryVariables
  >(DashboardCheckUpDocument, options);
}
// @ts-ignore
export function useDashboardCheckUpSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardCheckUpQuery,
    DashboardCheckUpQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DashboardCheckUpQuery,
  DashboardCheckUpQueryVariables
>;
export function useDashboardCheckUpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DashboardCheckUpQuery,
        DashboardCheckUpQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DashboardCheckUpQuery | undefined,
  DashboardCheckUpQueryVariables
>;
export function useDashboardCheckUpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DashboardCheckUpQuery,
        DashboardCheckUpQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DashboardCheckUpQuery,
    DashboardCheckUpQueryVariables
  >(DashboardCheckUpDocument, options);
}
export type DashboardCheckUpQueryHookResult = ReturnType<
  typeof useDashboardCheckUpQuery
>;
export type DashboardCheckUpLazyQueryHookResult = ReturnType<
  typeof useDashboardCheckUpLazyQuery
>;
export type DashboardCheckUpSuspenseQueryHookResult = ReturnType<
  typeof useDashboardCheckUpSuspenseQuery
>;
export type DashboardCheckUpQueryResult = Apollo.QueryResult<
  DashboardCheckUpQuery,
  DashboardCheckUpQueryVariables
>;
